import React from 'react'
import { Span } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { localizeCurrency, sumTotal } from '../utils'
import { GridElement } from '../GridElement'
import { GridTable } from '../GridTable'

interface TableTotalProps {
  payments: string[]
  remittances: string[]
}

export const MonthTotal: React.FC<TableTotalProps> = ({
  payments,
  remittances,
}) => {
  const { t } = useTranslation(['payments'])

  return (
    <GridTable className="mt-2">
      <GridElement columns={2}>
        <Span bold>{t('payments:saldo')}</Span>
      </GridElement>

      <GridElement columns={2} align="right">
        <Span bold>
          {localizeCurrency(
            sumTotal(remittances.map((s) => Number(s))) -
              sumTotal(payments.map((s) => Number(s)))
          )}
        </Span>
      </GridElement>
    </GridTable>
  )
}
